import { createStore } from "vuex";
import device from "./modules/device";
import menu from "./modules/menu";

export default createStore({
  modules: {
    device,
    menu,
  },
  strict: true,
});
